import { ChangeDetectionStrategy, Component } from '@angular/core';
import { UserService } from '@shared/services/user.service';
import { XPartnerService } from '@shared/services/x-partner.service';
import { NavigateService } from '@core/routes/services/navigate.service';

@Component({
  selector: 'df-public-pricing',
  templateUrl: './public-pricing.component.html',
  styleUrls: ['./public-pricing.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PublicPricingComponent {
  constructor(
    public readonly userService: UserService,
    public readonly xPartnerService: XPartnerService,
    public readonly n: NavigateService,
  ) {}
}
